import { render, staticRenderFns } from "./AnggotaSelect.vue?vue&type=template&id=47324017&scoped=true"
import script from "./AnggotaSelect.vue?vue&type=script&lang=js"
export * from "./AnggotaSelect.vue?vue&type=script&lang=js"
import style0 from "./AnggotaSelect.vue?vue&type=style&index=0&id=47324017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47324017",
  null
  
)

export default component.exports